import React, { useEffect, useState } from 'react';
import { Form, Typography, Input, Table } from 'antd';
import { Select, MenuItem } from '@mui/material';
import GenericModal from '../../buttons/genericModal';
import { linkBankAccountGenericMulti } from '../../../helpers/newBankAccount';
import { createMultiPostObject } from '../../../helpers/linkBankAccount';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import SelectBankAccountTag from '../../specific/customTags/selectBankAccountTag';

const { Text } = Typography;

function LinkToDashboard(props) {
	const [submitting, setSubmitting] = useState(false);
	const [selectedRows, setSelectedRows] = useState(props.selectedRows || []);
  	const [bankAccountPurposes, setBankAccountPurposes] = useState(JSON.parse(window.localStorage.getItem("bankAccountPurposes")));

	useEffect(() => {
		return () => {
			props.handleCancelModal();
		};
	}, []);

	useEffect(() => {

		setSelectedRows((prevState) => {
			const newSelectedRows = prevState.filter((account) => {
				return account.source !== "ICS" // hack to avoid duplicate linkage of ics accounts, also will cause errors
			})
			return newSelectedRows;
		});
	}, [props, props.selectedRows]);

	const onFormSubmitModal = (values) => {
		setSubmitting(true);
		linkBankAccountGenericMulti(
			createMultiPostObject(values, selectedRows, props.source),
			[...Array(Object.keys(values).length).keys()],

			(responseData) => {
				setSubmitting(false);
				props.onSuccess(responseData);
				props.handleCancelModal();
			},
			() => {
				setSubmitting(false);
			},
		);
	};

	const deleteRow = (bankAccountId) => {
		setSelectedRows((prevState) => {
			const newSelectedRows = prevState.filter((account) => {
				return account.key !== bankAccountId
			})
			return newSelectedRows;
		});
	}

	const updateRow = (value, bankAccountId, field) => {
		setSelectedRows((prevState) => {
			const newSelectedRows = prevState.map((account) => {
				if (account.key === bankAccountId) {
					return {
						...account,
						[field]: value,
					}
				}
				return account;
			});
			return newSelectedRows;
		});
	}

	const columns = [
		{
			title: 'Institution',
			dataIndex: 'institution',
			key: 'institution',
		},
		{
			title: 'Account',
			dataIndex: 'account',
			key: 'account',
			render: (text, record) => {
				let ret = record.account;
				const last4 = record.last4;
				const isValidLast4 = (
					last4 !== undefined
					&& last4.length > 3
					&& last4.length < 7);
				return (
					<div style={{ display: 'flex', flexDirection: 'column' }}>
						<Typography.Text type="primary">{ret}</Typography.Text>
						{isValidLast4 && (
							<Typography.Text type="secondary" italic>....{last4}</Typography.Text>
						)}
					</div>
				);
			}
		},
		{
			title: 'Entity',
			dataIndex: 'entityName',
			key: 'entityName',
		},
		{
			title: 'Purpose',
			render: (text, record) => (
			  <Select
				value={record.purpose?.id || ""}
				onChange={(event) => {
				  const selectedPurpose = bankAccountPurposes.find(purpose => purpose.id === event.target.value);
				  if (selectedPurpose) {
					updateRow(selectedPurpose, record.key, "purpose");
				  }
				}}
				displayEmpty
				fullWidth
				size="small"
				sx={{ minWidth: 150 }}
			  >
				<MenuItem value="" disabled>Select Purpose</MenuItem>
				{bankAccountPurposes.map((purpose) => (
				  <MenuItem key={purpose.id} value={purpose.id}>
					{purpose.name}
				  </MenuItem>
				))}
			  </Select>
			),
		},
		{
			title: 'Placement',
			render: (text, record) =>
				<SelectBankAccountTag
					groups={props.groups}
					customTags={props.flattenedTags}
					loading={props.flattenedTagsLoading || props.groupsLoading}
					placeholder={"Select tags to associated with this account"}
					includeUncategorized={false}
					multiSelect={true}
					required={true}
			  />
		},
		{
			title: 'Name',
			dataIndex: 'name',
			key: 'name',
			render: (text, record) =>
				<Input
					value={record.name?.length ? record.name : record.account}
					onChange={(e) => updateRow(e.target.value, record.key, "name")}
				/>
		},
		{
			title: '',
			key: 'remove',
			render: (text, record) =>
				<Button
					disableElevation fullWidth size="small" type="submit" variant="outlined" color="secondary"
					sx={{ fontSize: 12, textTransform: 'none' }}
					onClick={() => deleteRow(record.key)}
				>Remove</Button>,
		},
	];

	return (
		<GenericModal
			size='xl'
			visible={props.visible}
			handleCancelModal={() => props.handleCancelModal()}
			showModal={() => props.handleShowModal()}
			modalTitle="Link accounts to dashboard"
			modalBody={
				<Form
					layout="vertical"
					name="basic"
					onFinish={onFormSubmitModal}
					autoComplete="off"
				>
					<Table
						columns={columns}
						dataSource={selectedRows}
					/>
					<Form.Item>
						<LoadingButton
							type="primary"
							htmlType="submit"
							loading={submitting}
							loadingPosition="start"
							style={{ margin: "3px", width: "100%" }}
							disableElevation fullWidth size="small" variant="contained" color="primary"
							sx={{ fontSize: 12, textTransform: 'none' }}
						>
							Submit
						</LoadingButton>
					</Form.Item>
				</Form>
			}
		/>
	)
}

export default LinkToDashboard